import React, { memo, useCallback } from 'react';

const SkipToContent = memo(() => {
  const handleClick = useCallback((e) => {
    e.preventDefault();
    const mainContent = document.getElementById('main-content') || document.querySelector('main');
    if (mainContent) {
      mainContent.focus({ preventScroll: false });
      mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <div data-nosnippet>
      <a
        href="#main-content"
        className="skip-to-content"
        onClick={handleClick}
        aria-label="Skip to main content"
      >
        Skip to main content
      </a>
    </div>
  );
});

SkipToContent.displayName = 'SkipToContent';

export default SkipToContent;

